const API_BASE = process.env.REACT_APP_API_URL || '';

export async function getExportCatalog(orgId) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/exports/catalog`, {
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    throw new Error('Failed to fetch export catalog');
  }
  
  const data = await response.json();
  return data.datasets;
}

export async function getDataset(orgId, datasetId) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/exports/catalog/${datasetId}`, {
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    throw new Error('Failed to fetch dataset');
  }
  
  const data = await response.json();
  return data.dataset;
}
